import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import XAUUSDPredictor from './components/XAUUSDPredictor';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFD700',
    },
    secondary: {
      main: '#00C853',
    },
    background: {
      default: '#0d1117',
      paper: '#161b22',
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0d1117',
        padding: '24px',
      }}>
        <XAUUSDPredictor />
      </div>
    </ThemeProvider>
  );
}

export default App;
